import { isNumber } from 'lodash-es';

interface useJobRevisionProps {
  revisionId?: number;
}

export const useJobRevision = (props: useJobRevisionProps) => {
  return isNumber(props?.revisionId) && props?.revisionId > 0;
};
